import { LoadingOverlay, ScrollArea, Stack } from '@mantine/core';
import { useState } from 'react';
import { useProcessAnalysisStore } from '../../../../../store/process-analysis-store/process-analysis-store';
import { Divider } from '../../../../../ui-library/divider/divider';
import { useWorkUnitsData } from '../../../hooks/work-units';
import { useScrollToTop } from '../../../process-analysis.hooks';
import { SideSectionContent } from './side-section-content';
import { SideSectionHeader } from './side-section-header';
import { SideSectionTabs } from './side-section-tabs';
import { useMeasureMetadata } from './side-section.hooks';
import { SideSectionTab } from './side-section.type';

export const SideSection = () => {
  const scrollAreaRef = useScrollToTop();
  const selectedDataPoint = useProcessAnalysisStore((state) => state.selectedDataPoint);
  const measureMetadata = useMeasureMetadata();
  const [activeTab, setActiveTab] = useState<SideSectionTab>(SideSectionTab.Details);

  const { isLoading } = useWorkUnitsData();

  if (!selectedDataPoint || !measureMetadata) {
    return null;
  }

  return (
    <Stack h="100%" pos="relative">
      <LoadingOverlay
        visible={activeTab === SideSectionTab.WorkUnits && isLoading}
        overlayProps={{ blur: 2 }}
        style={{ zIndex: 200 }}
      />
      <SideSectionHeader />
      <Divider />
      <SideSectionTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      <Divider />
      <ScrollArea viewportRef={scrollAreaRef} style={{ flex: 1 }} scrollbarSize={0}>
        <SideSectionContent activeTab={activeTab} />
      </ScrollArea>
    </Stack>
  );
};
